import { Box, Grid, Typography, Skeleton, Card, Divider } from '@mui/material'
import SearchBar from '../../components/ui/SearchBar'
import StateSelect from '../../components/ui/StateSelect'
import { useEffect } from 'react'
import { GoogleMap, useJsApiLoader, Marker, OverlayViewF, OVERLAY_MOUSE_TARGET } from '@react-google-maps/api'
import React, { useState, useRef, useCallback } from 'react'
import axios from 'axios'
import { OurDearUrl } from '../../common/url'
import InfiniteScroll from 'react-infinite-scroll-component'
import MapICON from '../../assets/map-marker/map_marker.png'
import MapHighLightICON from '../../assets/map-marker/map_maker_highlight.png'
import { Empty } from 'antd'
import { isTablet } from 'react-device-detect'
import IconPay from '../../assets/repayment-channel/pay.png'

const containerStyle = {
  width: '700px',
  height: '858px',
  borderRadius: '10px',
}

export const SMOurDealer: React.FC = () => {

  const [zoom, setZoom] = useState(8)

  const [isLoadMap, setIsLoadMap] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)

  const [pageCount, setPageCount] = useState(1)

  const scrollRef = useRef()

  // const mapRef = useRef()

  const [searchText, setSearchText] = useState('')

  const [stateText, setStateText] = useState('')

  const [makerText, setMakerText] = useState('')

  const [mapInstance, setMapInstance] = useState<google.maps.Map>()

  const [currentId, setCurrentId] = useState(-1)

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDpRhUxHc-FK0hWoIf8VeSSoIZDEPwQ3-A',
  })

  const [center, setCenter] = useState({
    lat: 3.12,
    lng: 101.70,
  })

  const [data, setData] = useState(null)

  const [mapData, setMapData] = useState(null)

  const skeletonData = ['', '', '', '', '', '']

  const [overlayData, setOverlayData] = useState(null)

  const skeletonItem = (index: number) => {
    return (
      <Grid item key={index} xs={6}>
        <Box>
          <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'260px'} style={{ borderRadius: '4px' }}></Skeleton>
          <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'80%'} height={'22px'} style={{ marginTop: '26px', borderRadius: '4px' }}></Skeleton>
          <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'60%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
          <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'40%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
        </Box>
      </Grid>
    )
  }

  useEffect(() => {
    if (navigator.geolocation && isLoadMap === false) {
      console.log('支持定位')
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          setIsLoadMap(true)
          console.log('定位成功:' + position.coords.latitude)
          setCenter({ lat: position.coords.latitude, lng: position.coords.longitude })
        },
        (positionError: GeolocationPositionError) => {
          console.log('定位失败了')
        }
      )
    } else {
      console.log('不支持定位')
    }

    ; (async () => {
      await fetchList(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, stateText, makerText])

  const fetchList = async (isMore: boolean) => {
    try {
      const page = isMore ? currentPage + 1 : 1
      var url = OurDearUrl + '?pagination[page]=' + page + '&pagination[pageSize]=25&sort=sequence:ASC&publicationState=live'
      if (searchText !== null && searchText.length > 0) {
        url = url + '&filters[dearName][$contains]=' + searchText
      }
      if (stateText !== null && stateText.length > 0) {
        url = url + '&filters[state][$eq]=' + stateText
      }
      if (makerText !== null && makerText.length > 0) {
        url = url + '&filters[maps][$eq]=' + makerText
      }
      const response = await axios.get(url)
      if (response.status === 200) {
        if (isMore) {
          setCurrentPage(response.data['meta']['pagination']['page'])
          setPageCount(response.data['meta']['pagination']['pageCount'])
          setData([...data, ...response.data['data']])
          if (makerText === null || makerText === '') {
            setMapData([...mapData, ...response.data['data']])
          }
        } else {
          setData(null)
          setCurrentPage(response.data['meta']['pagination']['page'])
          setPageCount(response.data['meta']['pagination']['pageCount'])
          setData(response.data['data'])
          if (makerText === null || makerText === '') {
            setMapData(response.data['data'])
          }
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const loadMoreData = async () => {
    if (currentPage < pageCount) {
      fetchList(true)
    }
  }

  const clearAction = () => {
    setStateText('')
  }

  // const clearMakerText = () => {
  //   setMakerText('')
  // }

  const onLoadMap = useCallback((instance: google.maps.Map) => {
    setMapInstance(instance)
  }, [])

  const makerAction = (index: number) => {
    setOverlayData(mapData[index])
    setMakerText(mapData[index]['attributes']['maps'])
    setCenter({ lat: parseFloat(mapData[index]['attributes']['maps'].split(',')[0]), lng: parseFloat(mapData[index]['attributes']['maps'].split(',')[1]) })
    mapInstance?.panTo({ lat: parseFloat(mapData[index]['attributes']['maps'].split(',')[0]), lng: parseFloat(mapData[index]['attributes']['maps'].split(',')[1]) })
    mapInstance?.setZoom(18)
    setZoom(18)
  }

  const updateCurrentId = (id: number) => {
    setCurrentId(id)
  }

  const clearMarker = () => {
    if (makerText !== null && makerText !== '') {
      setCurrentId(-1)
      setOverlayData(null)
      setMakerText('')
      setCenter({
        lat: 3.12,
        lng: 101.70,
      })
      mapInstance?.setZoom(8)
      setZoom(8)
    }
  }


  const [showPopup, setShowPopup] = useState(false)
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 })

  // 点击图标时弹出弹窗
  const handleIconClick = (e) => {
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    setPopupPosition({
      top: rect.bottom + window.scrollY + 5,   // 图片下方 5px
      left: rect.left + window.scrollX          // 与图片 left 对齐
    })
    setShowPopup(true)
  }

// 点击其他地方关闭弹窗
const handleClickOutside = () => {
  setShowPopup(false)
}

// 在组件渲染部分添加点击外部关闭
useEffect(() => {
  if (showPopup) {
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }
}, [showPopup])

  // ======================= VIEWS
  return (
    <Box
      sx={{
        width: '100%',
        paddingLeft: isTablet ? '30px' : '60px',
        paddingRight: isTablet ? '30px' : '60px',
        paddingTop: '30px',
        paddingBottom: '0px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* header:search、select*/}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          paddingRight: '20px',
        }}
      >
        <SearchBar
          onChange={(e) => {
            clearMarker()
            setSearchText(e.target.value)
          }}
          sx={{
            width: '50%',
            '& .MuiOutlinedInput-root.Mui-focused': {
              '& > fieldset': {
                borderColor: '#E4E7ED',
              },
            },
            '& .MuiOutlinedInput-root:hover': {
              '& > fieldset': {
                borderColor: '#E4E7ED',
              },
            },
          }}
          inputProps={{
            sx: {
              '&::placeholder': {
                color: '#D1D5DB',
              },
            },
          }}
        />

        <Box
          sx={{
            width: '16px',
          }}
        ></Box>

        <StateSelect
          onChange={(e) => {
            console.log('state===' + e)
            clearMarker()
            setStateText(e)
          }}
          clearAction={clearAction}

        />
        <Box
          sx={{
            width: '700px',
          }}
        ></Box>
      </Box>
      {/* list 、 map*/}
      <Box
        sx={{
          width: '100%',
          height: '912px',
          flex: '1',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {/* body:grid */}

        <Box
          sx={{
            width: '100%',
            height: '900px',
            marginTop: '60px',
            marginRight: isTablet ? '0px' : '30px',
            paddingRight: '20px',
            paddingBottom: '12px',
            overflow: 'scroll',
            '::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {data === null ? (
            <Box>
              <Grid container height={'900px'} columnSpacing={isTablet ? '12px' : '24px'} rowSpacing={isTablet ? '12px' : '24px'}>
                {skeletonData.map((item, index) => skeletonItem(index))}
              </Grid>
            </Box>
          ) : data.length === 0 ? (
            <Box sx={{ paddingTop: '100px' }}>
              <Empty description={<Typography>Oops! No result found.</Typography>}>
                <Typography color={'#B2B2B2'}>Please try search options or filter that are available.</Typography>
              </Empty>
            </Box>
          ) : (
            <InfiniteScroll
              height={'900px'}
              dataLength={data.length}
              next={loadMoreData}
              hasMore={currentPage < pageCount ? true : false}
              loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
              endMessage={
                <Box sx={{
                  paddingTop: '40px',
                  paddingBottom: '40px',
                  paddingLeft: '0px',
                  paddingRight: '10px',
                }}>
                  <Divider sx={{ background: 'rgba(57, 33, 245, 0.15)' }} />
                </Box>
              }
              ref={scrollRef}
            >
              <Grid id={'scrollView'} container columnSpacing={isTablet ? '12px' : '24px'} rowSpacing={isTablet ? '12px' : '24px'}>
                {data.map((item, index) => (
                  <Grid key={index} item xs={6}>
                    <Box onClick={() => updateCurrentId(data[index]['id'])} 
                      sx={{
                        width: '244px',
                        cursor: 'pointer',
                        '&:hover': {
                          //boxShadow: '0 0 10px 5px rgba(20, 31, 57, 0.06)',
                          border: '1px solid #FBBF23',
                          borderRadius: '10px',
                          bgcolor: '#F6F6F6'
                        }
                      }}
                    >
                      <Card sx={{
                        bgcolor: 'transparent',
                        borderRadius: '10px',
                        boxShadow: 'none',
                        border: 'none',
                      }}>
                        <div dangerouslySetInnerHTML={{ __html: data[index]['attributes']['image'] }} style={{ minHeight: '200px', borderRadius: '10px' }} />
                      </Card>

                      <div style={{
                        paddingTop: '24px', 
                        paddingLeft: '5px',
                        display: 'block'
                      }}>
                        <span style={{ 
                          display: 'inline-block',  // 改为 inline-block
                          color: '#141F39',
                          fontSize: '20px',
                          fontWeight: '700',
                          wordBreak: 'break-word',
                          lineHeight: '1.6',
                          maxWidth: '100%'   // 确保不溢出
                        }}>
                          {data[index]['attributes']['dearName']}
                          {/* <img 
                            src={IconPay} 
                            alt="icon" 
                            style={{ 
                              width: 20, 
                              height: 20,
                              verticalAlign: 'middle',
                              marginLeft: '4px',
                              marginBottom: '3px',
                              display: 'inline'
                            }} 
                            onClick={handleIconClick}
                          /> */}
                        </span>
                      </div>

                      {/* 弹窗 */}
                      {showPopup && (
                        <div
                          style={{
                            position: 'absolute',
                            top: popupPosition.top,
                            left: popupPosition.left,
                            backgroundColor: '#FFC107',
                            borderRadius: '5px',
                            padding: '10px 10px',
                            boxShadow: '1px 1px 5px rgba(0,0,0,0.01)', 
                            zIndex: 9999,
                            width: '260px',
                            animation: 'fadeIn 0.15s ease'
                          }}
                          >
                            <Typography fontSize={12} fontWeight={600} color={'#141F39'} textAlign={'left'} paddingBottom={'5px'}>
                                Payment at Merchant - BAYAQ KEDAI
                            </Typography>
                            <Typography fontSize={10} fontWeight={400} color={'#141F39'} textAlign={'left'}>
                                Pay your monthly installment in person at our strategic partner's location.
                            </Typography>
                        </div>
                      )}

                      <Box
                        sx={{
                          paddingTop: '10px',
                          paddingLeft: '5px',
                        }}
                      >
                        <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                          {data[index]['attributes']['mapsInfo']}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          paddingTop: '10px',
                          paddingLeft: '5px',
                        }}
                      >
                        <Typography fontSize={12} fontWeight={400} color={'#6B6B6B'}>
                          Tel：+{data[index]['attributes']['phone']}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </InfiniteScroll>
          )}
        </Box>
        {/* map */}
        <Box
          sx={{
            width: isTablet ? '480px': '744px',
            height: '858px',
            backgroundColor: '#F2F2F2',
            marginTop: '60px',
            borderRadius: '10px',
          }}
        >
          {isLoaded ? (
            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={zoom} onLoad={onLoadMap}
              options={{
                mapTypeControl: true,
                mapTypeControlOptions: {
                  position: google.maps.ControlPosition.TOP_RIGHT,
                },
                streetViewControl: true,
                fullscreenControl: true,
                // default hide all poi and prevent keyboard action, can be overwritten by mapProps
                keyboardShortcuts: true,
                styles: [
                  {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off' }],
                  },
                ],
              }}
            >
              {/* Child components, such as markers, info windows, etc. */}
              {mapData === null ? (
                <></>
              ) : (
                mapData.map((item, index) => (
                  mapData[index]['attributes']['maps'] !== null && String(mapData[index]['attributes']['maps']).includes(',') ?
                    <Marker
                      key={index}
                      icon={currentId === mapData[index]['id'] ? MapHighLightICON : MapICON}
                      position={{ lat: parseFloat(mapData[index]['attributes']['maps'].split(',')[0]), lng: parseFloat(mapData[index]['attributes']['maps'].split(',')[1]) }}
                      title={mapData[index]['attributes']['dearName']}
                      onClick={() => makerAction(index)}
                    >
                    </Marker>
                    :
                    null
                ))
              )}
              {overlayData === null ? null : (<OverlayViewF position={center} mapPaneName={OVERLAY_MOUSE_TARGET} getPixelPositionOffset={{ x: 10, y: 6 }}>
                <Box sx={{ paddingLeft: '16px', paddingRight: '16px', paddingBottom: '16px', width: '244px', backgroundColor: '#FFFFFF', boxShadow: '0px 10px 80px 3px #0000001A', borderRadius: '8px', transform: 'translateX(-110%) translateY(-60%)' }}>
                  <Card style={{
                    borderRadius: '4px',
                    boxShadow: 'none',
                    border: 'none',
                    '&:hover': {
                      boxShadow: '0px 10px 30px 3px #0000001A',
                    }
                  }}>
                    <div dangerouslySetInnerHTML={{ __html: overlayData['attributes']['image'] }} style={{ minHeight: '225px', borderRadius: '4px' }} />
                  </Card>

                  <Box
                    sx={{
                      paddingTop: '24px',
                    }}
                  >
                    <Typography fontSize={20} fontWeight={700} color={'#141F39'}>
                      {overlayData['attributes']['dearName']}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      paddingTop: '10px',
                    }}
                  >
                    <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                      {overlayData['attributes']['mapsInfo']}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      paddingTop: '10px',
                    }}
                  >
                    <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'}>
                      Tel：+{overlayData['attributes']['phone']}
                    </Typography>
                  </Box>
                </Box>
              </OverlayViewF>)}
            </GoogleMap>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Box>
  )
}

// ======================= EXPORT
export default SMOurDealer
